import { render, staticRenderFns } from "./documentIcon.vue?vue&type=template&id=c4b26bac&scoped=true"
import script from "./documentIcon.vue?vue&type=script&lang=js"
export * from "./documentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b26bac",
  null
  
)

export default component.exports